import { useEffect, useRef } from 'react';
/**
 * Provide a callback for any document event type.
 *
 * @event {string} type - A valid [DOM event](https://developer.mozilla.org/en-US/docs/Web/Events).
 * @param {Function} callback - Callback when specified event type occurs.
 *
 * @example
 *
 * function App() {
 *   useDocumentEvent('keydown', event => {
 *     console.log(`${event.key} pressed`)
 *   })
 *   return <div>App</div>
 * }
 */

export function useDocumentEvent(type, callback) {
  var savedCallback = useRef(callback);
  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(function () {
    function handleEvent(event) {
      savedCallback.current(event);
    }

    document.addEventListener(type, handleEvent);
    return function () {
      document.removeEventListener(type, handleEvent);
    };
  }, []);
}